import { mapActions } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      id: null,
      submitLoading: false,
      types: {
        CREATE: 'create',
        UPDATE: 'update'
      }      
    }
  },
  computed: {
    formType () {
      return this.id ? this.types.UPDATE : this.types.CREATE
    }
  },
  methods: {
    ...mapActions(['showNotification']),
    async _submit (name = 'observer') {
      // A v-form answers { valid, errors } where vee-validate's observer
      // answered a boolean.
      const { valid } = await this.$refs[name].validate()
      if (!valid || this.submitLoading) {
        return
      }
      try {
        this.submitLoading = true
        if (await this.handleForm(name) && this.successMessage) {
          this.showNotification({ text: this.successMessage, color: 'success' })
        }
      } catch (err) {
        this.showNotification({ text: err.message, color: 'red' })
      } finally {
        this.submitLoading = false
      }
    },
    _reset (name = 'observer') {
      // resetValidation, not reset: the observer's reset() cleared the error
      // state and left the values alone, and a v-form's reset() empties them.
      if (this.$refs[name]) {
        this.$refs[name].resetValidation()
      }
    }
  },
  mounted () {
    this._reset()
    if (this.refresh) {
      this.refresh()
    }
  }
}

